import React from 'react';
import PropTypes from 'prop-types';
import { TextStyled } from './styles/TextStyled';

const Text = ({
  children,
  isMobile = false,
  hover = '',
  tag = 'span',
  color = '',
  size = '',
  type = '',
  font = '',
  disable = false,
  getRef = Function.prototype,
  className = '',
  fixedSize = false,
  weight = '',
  ...props
}) => (
  <TextStyled
    {...props}
    className={className}
    as={tag}
    type={type}
    color={color}
    size={size}
    font={font}
    isMobile={isMobile}
    ref={getRef}
    hover={hover}
    disable={disable}
    weight={weight}
    fixedSize={fixedSize}
  >
    {children}
  </TextStyled>
);

Text.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  font: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  type: PropTypes.string,
  hover: PropTypes.string,
  disable: PropTypes.bool,
  isMobile: PropTypes.bool,
  getRef: PropTypes.func,
  className: PropTypes.string,
  fixedSize: PropTypes.bool,
  weight: PropTypes.string,
};

export default React.memo(Text);
